export const SET_PAGE_META = 'page/SET_PAGE_META';
export const SET_NO_PERMISSION = 'SET_NO_PERMISSION';
